/**
 * Token Manager
 *
 * Manages access token retrieval for API requests.
 * This allows the API client to get tokens without React dependencies.
 */

let tokenGetter: (() => Promise<null | string>) | null = null;

/**
 * Set the token getter function
 * This should be called from the auth provider to provide access to Kinde's getAccessToken
 */
export const setTokenGetter = (getter: () => Promise<null | string>) => {
	tokenGetter = getter;
};

/**
 * Get the current access token
 * Returns null if no token is available or if token getter is not set
 */
export const getAccessToken = async (): Promise<null | string> => {
	if (!tokenGetter) {
		return null;
	}
	try {
		return await tokenGetter();
	} catch (error) {
		console.error("Error getting access token:", error);
		return null;
	}
};
